import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../config';
interface CtaButtonProps {
  children: React.ReactNode;
  className?: string;
  sublabel?: string;
}
export function CtaButton({
  children,
  className = '',
  sublabel
}: CtaButtonProps) {
  return <div className="w-full flex flex-col items-center" data-id="element-71">
      <motion.a href={CHECKOUT_URL} whileHover={{
      scale: 1.03
    }} whileTap={{
      scale: 0.97
    }} animate={{
      scale: [1, 1.025, 1]
    }} transition={{
      scale: {
        duration: 1.8,
        repeat: Infinity,
        ease: 'easeInOut'
      }
    }} className={`group relative flex w-full items-center justify-center gap-2 rounded-2xl bg-brand-pink px-6 py-4 text-center text-lg font-extrabold uppercase leading-tight tracking-tight text-white shadow-[0_10px_0_0_#a3185f] transition-all active:translate-y-1 active:shadow-[0_4px_0_0_#a3185f] sm:text-xl ${className}`} data-id="element-72">
        <span className="drop-shadow-sm" data-id="element-73">{children}</span>
        <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform group-hover:translate-x-1" data-id="element-74" />
      </motion.a>
      {sublabel && <p className="mt-2 text-center text-xs font-semibold text-brand-purpleDark/70 sm:text-sm" data-id="element-75">
          {sublabel}
        </p>}
    </div>;
}